import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2, Upload } from "lucide-react";
import { api } from "../../lib/api";
import { resolveMedia } from "../../lib/media";

const inp = "w-full border border-zinc-300 px-2 py-1.5 text-sm";

export default function AdminUrgentPhotoUpload({ rescue, headers, onChanged }) {
  const [file, setFile] = useState(null);
  const [f, setF] = useState({ photo_attribution: rescue.photo_attribution || "", photo_caption: rescue.photo_caption || "", photo_source_url: "" });
  const [busy, setBusy] = useState(false);

  const upload = async () => {
    if (!file) return toast.error("Choose a photo first.");
    if (f.photo_attribution.trim().length < 3) return toast.error("Add who took / provided the photo.");
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    Object.entries(f).forEach(([k, v]) => fd.append(k, v));
    try {
      await api.post(`/admin/urgent-rescues/${rescue.id}/photo/upload`, fd, { headers });
      toast.success("Photo updated.");
      setFile(null);
      onChanged();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Upload failed.");
    } finally { setBusy(false); }
  };

  return (
    <div className="flex flex-wrap gap-4" data-testid="urgent-photo-upload">
      {rescue.photo_url && <img src={resolveMedia(rescue.photo_url)} alt="" className="w-40 h-40 object-cover border" data-testid="urgent-photo-current" />}
      <div className="flex-1 min-w-[240px] space-y-2 max-w-md">
        <input type="file" accept="image/png,image/jpeg,image/gif,image/webp" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="urgent-photo-file" />
        <input placeholder="Photo by / provided by *" value={f.photo_attribution} onChange={(e) => setF({ ...f, photo_attribution: e.target.value })} className={inp} data-testid="urgent-photo-attribution" />
        <input placeholder="Caption" value={f.photo_caption} onChange={(e) => setF({ ...f, photo_caption: e.target.value })} className={inp} data-testid="urgent-photo-caption" />
        <input placeholder="Source link (optional)" value={f.photo_source_url} onChange={(e) => setF({ ...f, photo_source_url: e.target.value })} className={inp} data-testid="urgent-photo-source" />
        <button onClick={upload} disabled={busy} className="btn-danger disabled:opacity-60" data-testid="urgent-photo-upload-btn">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />} Upload photo
        </button>
      </div>
    </div>
  );
}
